<template>
    <div class="text-over-image">
        <div class="text-over-image-wrapper">
            <div class="text-over-image-content">
                <ContentComponentItem
                    v-for="(component, key) in data.content"
                    :key="key"
                    :background="'BLUE'"
                    :data="component"
                    :page-type="pageType"
                />
            </div>

            <div class="image">
                <CmsImage
                    :data="data.image"
                    :is-eager="hasEagerImage"
                    fit="cover"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ComponentTextOverImageFragment } from '@/graphql/api'

import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'
import CmsImage from '@/components/cms/CmsImage.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

defineProps<{
    data: ComponentTextOverImageFragment
    hasEagerImage?: boolean
    pageType: PageType
}>()
</script>

<style lang="scss" scoped>
.text-over-image {
    width: 100%;
    height: calc(100vw - 40px);
    min-height: 430px;
    padding: 40px 20px;
    position: relative;

    @include min-width(640) {
        height: 430px;
    }

    @include min-width(1024) {
        padding: 0;
        height: 540px;
    }

    .page-block.flex & {
        @include min-width(1024) {
            width: 40%;
            flex-grow: 1;
        }
    }

    .text-over-image-wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 2;
        background-size: cover;
        background-position: center center;
        display: flex;

        .text-over-image-content {
            position: relative;
            margin-top: auto;
            width: 100%;
            padding: 20px;
            z-index: 2;
            background: linear-gradient(
                180deg,
                rgba($black, 0),
                rgba($black, 0.5)
            );
        }
    }

    .image {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
    }
}
</style>
